import apiClient from './client';
import type { QuotaResponse } from '../../types/api.types';

export const quotaApi = {
  async checkQuota(): Promise<QuotaResponse> {
    try {
      const response = await apiClient.get<QuotaResponse>('/api/quota');
      return response.data;
    } catch (error) {
      console.error('Error checking quota:', error);
      throw error;
    }
  },
};
